import { firebaseConfig } from './firebaseConfig';

/**
 * Runtime configuration for cloud features (Firebase Auth + Firestore sync).
 *
 * There is no separate backend: the extension talks to Firestore directly,
 * scoped per-user by security rules. Cloud features are gated purely on the
 * Firebase config being present (it is embedded, so they are on by default).
 */

/** Whether Firebase is configured (embedded public config). */
export const FIREBASE_ENABLED = Boolean(firebaseConfig.apiKey);

/** True when sign-in + Firestore sync should be available. */
export const CLOUD_FEATURES_ENABLED = FIREBASE_ENABLED;

/**
 * Base URL of the Netlify functions backing Stripe billing
 * (create-checkout-session / create-billing-portal / stripe-webhook) — the
 * sole billing backend since ExtPay was retired (ADR-010). Must also appear
 * in the manifests' host_permissions and CSP connect-src.
 */
export const BILLING_API_BASE =
  import.meta.env.VITE_BILLING_API_BASE ?? 'https://tpl-billing-api.netlify.app';

/**
 * The companion web app (ADR-012) — the extension's fullscreen view links to
 * it so users can install it as a desktop/taskbar app. Plain link only: no
 * host_permissions or CSP entry needed (it is opened as a tab, not fetched).
 */
export const WEB_APP_URL = import.meta.env.VITE_WEB_APP_URL ?? 'https://app.toppromptlibrary.com';
